/**
 * Keep browser tab title + favicon in sync with the active account.
 */

let accountFaviconUrl = '';
let defaultFaviconHrefs = null;

const faviconSelector =
  'link.favicon, link[rel="icon"], link[rel="shortcut icon"]';

const captureDefaultFavicons = () => {
  if (defaultFaviconHrefs) return;
  defaultFaviconHrefs = Array.from(
    document.querySelectorAll(faviconSelector)
  ).map(link => ({
    el: link,
    href: link.getAttribute('href') || '',
  }));
};

export const getAccountFaviconUrl = () => accountFaviconUrl;

export const restoreAccountOrDefaultFavicon = () => {
  if (accountFaviconUrl) {
    document.querySelectorAll(faviconSelector).forEach(link => {
      link.href = accountFaviconUrl;
    });
    return;
  }

  if (!defaultFaviconHrefs) return;
  defaultFaviconHrefs.forEach(({ el, href }) => {
    if (el && href) el.href = href;
  });
};

/**
 * @param {{ name?: string, logoUrl?: string }} branding
 */
export const applyAccountBranding = ({ name, logoUrl } = {}) => {
  captureDefaultFavicons();

  if (name) {
    document.title = name;
  }

  const nextLogo = logoUrl || '';
  accountFaviconUrl = nextLogo;

  if (nextLogo) {
    document.querySelectorAll(faviconSelector).forEach(link => {
      link.href = nextLogo;
    });
  } else {
    restoreAccountOrDefaultFavicon();
  }
};
